/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。
 * @export
 * @enum {number}
 */
export enum SortDirectionEnum {
    /** 昇順 */
    ASC = 'asc',
    /** 降順 */
    DESC = 'desc'
}

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 の Union 型
 * @export
 * @typedef SortDirection
 */
export type SortDirection =
  typeof SortDirectionEnum[keyof typeof SortDirectionEnum];

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 のラベルマップ
 * @export
 */
export const SortDirectionLabels = {
    /**
     * 数値キー: SortDirectionEnum.ASC
     * 名前キー:  ASC
     */
    [SortDirectionEnum.ASC]: '昇順',
    ASC:                             '昇順',
    /**
     * 数値キー: SortDirectionEnum.DESC
     * 名前キー:  DESC
     */
    [SortDirectionEnum.DESC]: '降順',
    DESC:                             '降順',
} as const;

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 のラベル Union 型
 * @export
 * @typedef SortDirectionLabel
 */
export type SortDirectionLabel =
  typeof SortDirectionLabels[keyof typeof SortDirectionLabels];

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 のラベル取得関数
 * @export
 * @param { SortDirection } value - 列挙体の値
 * @returns { SortDirectionLabel } ラベル文字列
 */
export function getSortDirectionLabel(
  value: SortDirection
): SortDirectionLabel {
  return SortDirectionLabels[value];
}

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 のラベル配列を取得する関数
 * @export
 * @param { SortDirection[] } values - 列挙体の値配列
 * @returns { SortDirectionLabel[] } ラベル文字列配列
 */
export function getSortDirectionLabels(values: SortDirection[]): SortDirectionLabel[] {
  return values.map((value) => getSortDirectionLabel(value));
}

/**
 * 一覧表示などで昇順（asc）または降順（desc）を指定するために使用。 のラベル配列
 * @export
 */
export const SortDirectionLabelList = [
  '昇順','降順',
] as const;

